<div class="dynamic-form-holder">
  <form (ngSubmit)="onSubmit()" [formGroup]="form()" class="full-width">

    <h4>Add a one-time fee for {{customerName}}:</h4>
    <p>This one-time fee will be added to the customer's next invoice.</p>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Amount</mat-label>
      <span matTextPrefix>$ &nbsp;</span>
      <input matInput type="number" [min]="0" [formControl]="amountControl">
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Description</mat-label>
      <input matInput type="text" [formControl]="descriptionControl">
    </mat-form-field>

    <button mat-fab extended color="secondary" type="button" (click)="dialogRef.close()">Cancel</button>
    <button mat-fab extended type="submit" [disabled]="!form().valid">Add Fee</button>

  </form>
</div>